import { useNavigate, useParams } from 'react-router-dom';
import { MdOutlineEventBusy } from 'react-icons/md';
import { RoutePlannerSideDrawer } from '@lp/features/RoutePlanner/components/RouteModals/components/RoutePlannerSideDrawer';
import { useCaseByIdQuery } from '@/queries/case';
import { useLogisticsLogs } from '@/queries/route-planner';
import { ChangeLogList } from './components/ChangeLogList';

export const LogisticsChangeLogDrawer = () => {
  const navigate = useNavigate();
  const { caseId } = useParams();
  const { data: caseData, isFetched: isCaseFetched } = useCaseByIdQuery(caseId);
  const { data: logisticsLogs, isFetched: isLogsFetched } = useLogisticsLogs(caseData?.logisticsReference?.id);

  const isDataFetched = isCaseFetched && isLogsFetched;

  return (
    <RoutePlannerSideDrawer
      isDismissable={false}
      isKeyboardDismissDisabled
      title="Logistics Details Change Log"
      isOpen
      isLoading={!isDataFetched}
      onClose={() => navigate(`/case/${caseId}/planner`)}
    >
      <div className="w-lg h-fit max-h-full">
        {!logisticsLogs?.logs?.length && (
          <div className="w-full flex flex-col grow items-center gap-2 py-12 text-base-25">
            <MdOutlineEventBusy size={28} />
            <span className="text-m-r">No Events to Display</span>
          </div>
        )}
        {!!logisticsLogs?.logs?.length && <ChangeLogList logs={logisticsLogs.logs} />}
      </div>
    </RoutePlannerSideDrawer>
  );
};
